import { render } from "./invitedfavourites.vue?vue&type=template&id=10f33768"
import script from "./invitedfavourites.vue?vue&type=script&lang=js"
export * from "./invitedfavourites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__